import Img from "../../assets/image/index";
import {
  Animatespin,
  Navbar,
  Experience,
  MainHeading,
  GalleryCom,
  Footer,
} from "../../components/index";
import GallerysBgColorsData from "../../js/gallerysBgColorsData";
import Icons from "../../assets/icon";
import sanitizeHtml from "../../js/sanitizeHtml";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Modal from "react-modal"; // or use your own modal
import Functions from "./index.function";
Modal.setAppElement("#root");
const EventDetails = () => {
  const {
    isOpen,
    selectedIndex,
    userId,
    loadingapi,
    handleSevedEvent,
    galleryImages,
    openGallery,
    closeGallery,
    singleEvent,
    isLoading,
    localimgpath,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <>
            <MainHeading
              title={singleEvent?.event_title}
              dis={""}
              layout={"h-18 sm:h-20 lg:h-36"}
              navigate={"/event"}
            />
            <div className="w-full xs:h-[150px] sm:h-[18rem] lg:h-[18rem] xl:h-[20rem] 2xl:h-[20rem] xs:mt-2">
              <img
                className="w-full h-full xs:rounded-3xl sm:rounded-[35px] lg:rounded-[70px] object-cover"
                src={
                  singleEvent?.banner === null
                    ? Img.filmfareAwardsImg
                    : `${localimgpath?.eventsBanner}/${singleEvent?.banner}`
                }
                alt={singleEvent?.event_title}
              />
              s
            </div>


            <div className="flex justify-between items-center">
                <h2 className="text-secondary font-unboundedMedium lg:text-3xl xs:pb-2 sm:pb-2 lg:mt-14 lg:pb-5">
                  Event Info
                </h2>
              </div>  
              <div
                className="prose text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(singleEvent?.short_description),
                }}
              />


            <div className="xs:pt-5 xs:pb-2 sm:pt-6 sm:pb-2 lg:pt-0 lg:pb-0">
              <div className="flex justify-between items-center">
                <h2 className="text-secondary font-unboundedMedium lg:text-3xl lg:mt-14 lg:pb-5">
                  About This Event
                </h2>
                <div
                  className={`group xs:w-10 xs:h-10 sm:w-10 sm:h-10 lg:w-12 lg:h-12 flex justify-center items-center rounded-full transition-all duration-300
                                hover:scale-110 cursor-pointer bg-[#1A1A1A] hover:bg-[#333333]`}
                  onClick={() => {
                    handleSevedEvent(userId, singleEvent?.id);
                  }}
                >
                  {loadingapi ? (
                    <div className="flex justify-center items-center">
                      <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary lg:w-6 lg:h-6 sm:w-4 sm:h-4 xs:w-3 xs:h-3"></div>
                    </div>
                  ) : (
                    <img
                      className={`xs:w-4 sm:w-4 lg:w-5 transition-all duration-300 group-hover:scale-110
                                                }`}
                      src={
                        singleEvent?.is_favourite
                          ? Icons.dasSavedIcon
                          : Icons.dasSaveIcon
                      }
                      alt={
                        singleEvent?.is_favourite
                          ? Icons.dasSavedIcon
                          : Icons.dasSaveIcon
                      }
                    />
                  )}
                </div>
              </div>
              <div
                className="prose text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(singleEvent?.description),
                }}
              />
            </div>
            {singleEvent?.galleries?.length > 0 && (
              <div className="lg:pt-3">
                <h2 className="text-secondary font-unboundedMedium lg:text-2xl">
                  Gallery
                </h2>
                <div className="flex flex-wrap xs:gap-3 lg:gap-4 xs:pt-5 xs:justify-center sm:justify-center sm:gap-4 sm:pt-6 lg:justify-center">
                  {Array.isArray(singleEvent?.galleries) &&
                  singleEvent?.galleries?.length > 0 ? (
                    singleEvent?.galleries.map((galleryItem, index) => (
                      <div
                        key={index}
                        onClick={() => openGallery(index)}
                        className="cursor-pointer"
                      >
                        <GalleryCom
                          latestNewsthubmail={
                            galleryItem?.image === null
                              ? Img.filmfareAwardsImg
                              : `${localimgpath?.eventsGallery}/${galleryItem?.image}`
                          }
                          alt={galleryItem?.galleryable_type}
                          layout={
                            "xs:w-32 xs:h-32 sm:w-40 sm:h-40 lg:w-56 lg:h-56 rounded-full"
                          }
                          Img={"w-[95%] h-[95%] rounded-full"}
                          bgcolor={
                            GallerysBgColorsData[
                              index % GallerysBgColorsData?.length
                            ]?.eventsGallerycolor
                          }
                        />
                      </div>
                    ))
                  ) : (
                    <p className="text-secondary">No gallery data available</p>
                  )}
                </div>
              </div>
            )}
            <Modal
              isOpen={isOpen}
              onRequestClose={closeGallery}
              contentLabel="Image Gallery Modal"
              className="w-full mx-0 sm:mx-auto p-4 sm:p-6 bg-primary rounded-lg shadow-xl overflow-y-auto"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            >
              <button
                onClick={closeGallery}
                className="absolute top-2 right-2 text-white text-xl z-10"
              >
                ✕
              </button>

              <ImageGallery
                items={galleryImages}
                startIndex={selectedIndex}
                showPlayButton={false}
                showFullscreenButton={true}
                showThumbnails={true}
                showIndex={true}
              />
            </Modal>
          </>
        )}
      </div>
      <div className="xs:pt-4 sm:pt-6 lg:pt-0">
        <Experience />
      </div>
      <Footer />
    </div>
  );
};

export default EventDetails;
